import { useCallback, useState, useEffect } from "react";

import { useUser } from "utils/hooks";
import API from "utils/api";

export default function useComments(type, id, page, filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchComments = useCallback(async () => {
    setLoading(true);

    const { response, data } = await API.fetchComments(token, type, id, page, filters);

    if (response.ok) {
      setResult(data);
      setLoading(false);
    } else {
      console.error(data);
    }
  }, [type, id, page, setLoading, setResult]);

  useEffect(() => {
    fetchComments();
  }, [type, id, page, setLoading, setResult]);

  return {
    loading,
    reload: fetchComments,
    comments: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
    pendingCount: result?.pendingCount ?? 0,
  };
}

